export interface IsFacebookOnlyUserEmailValidator {
    email?: string;
    isFacebookOnlyUser: boolean;
    forgotPasswordLink: string;
    t: Function;
}

export default (values: IsFacebookOnlyUserEmailValidator) => {
    const errors: { password?: string } = {};

    if (values.isFacebookOnlyUser) {
        errors.password = values.t('To keep your account secure, please %sclick here%s', [
            `<a href="${`${values.forgotPasswordLink}?email=${values.email}&actionType=create`}" target="_blank">`,
            '</a>',
        ]);
    }
    return errors;
};
